'use strict';
const angular = require('angular');

/*@ngInject*/
export function SurveysService($resource) {
  return $resource('/api/surveys/:id', {
    name: '@_id'
  },{
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduu.SurveysService', [])
  .factory('SurveysService', SurveysService)
  .name;



// WEBPACK FOOTER //
// ./client/services/surveys/surveys.service.js